export const GET_TIMEZONES = 'GET_TIMEZONES';
export const GET_TIMEZONES_ERROR = 'GET_TIMEZONES_ERROR';

export const GET_OFFSET_MINUTES = 'GET_OFFSET_MINUTES';
export const GET_OFFSET_MINUTES_ERROR = 'GET_OFFSET_MINUTES_ERROR';
export const GET_OFFSET_MINUTES_LOADING = 'GET_OFFSET_MINUTES_LOADING';



// WEBPACK FOOTER //
// ./src/state/timeZones/types.js